var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRedchat(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "64px",
    height: "64px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#eb0a0a",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(3.55556,3.55556)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.54492,10.19336c-4.671,0 -9.08728,2.84956 -11.11328,7.10156v14.70117l6.31836,3.89063l0.24023,-15.22266l11.93555,-8.08398c-2.006,-1.525 -4.79586,-2.38672 -7.38086,-2.38672zM47.50195,14.16406c-0.831,0 -2.02536,0.10181 -3.06836,0.38281l-11.43359,7.72266l-0.09961,6.67773l12.07422,-8.10156l14.64258,8.66406c0.195,-0.884 0.33984,-2.1213 0.33984,-3.0293c0,-6.877 -5.63808,-12.31641 -12.45508,-12.31641zM20.42383,19.90234c-5.456,1.565 -9.06734,6.29777 -9.02734,12.13477c0.013,1.777 0.48214,3.69084 1.24414,5.21484l15.38477,8.78516l6.19727,-3.87109l-13.79883,-8.46484zM45.07422,24.39453l-5.01367,3.41016l13.11719,8.30273l1.64453,14.8418c4.424,-1.901 7.74219,-6.34519 7.74219,-11.49219c0,-1.754 -0.44112,-3.69047 -1.20312,-5.35547zM37.27148,29.62891l-4.45312,2.96875l-0.01953,5.09375l4.33203,2.68945l4.61328,-2.86914l-0.14062,-5.11523zM44.73438,34.36328l0.3418,16.04492l-12.69727,7.48242c2.246,2.005 5.20023,3.0625 8.11523,3.0625c4.998,0 9.67547,-3.10286 11.48047,-7.75586l-1.64453,-15.34375zM41.86523,41.00195l-13.7793,8.56445l-12.81641,-7.30078c-0.211,0.92 -0.36133,2.15942 -0.36133,3.10742c0,6.551 5.35506,12.15641 11.91406,12.31641l15.20313,-9.04492z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedchat);
export default __webpack_public_path__ + "static/media/redchat.7cc08fcae57514be44888564ab4c02c9.svg";
export { ForwardRef as ReactComponent };